/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Display_Name_InvalidInputs */

const en_us2_account_display_name_invalid = /** @type {(inputs: Account_Display_Name_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your name needs 1 to 60 characters.`)
};

const pt_br2_account_display_name_invalid = /** @type {(inputs: Account_Display_Name_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu nome precisa ter de 1 a 60 caracteres.`)
};

const es_419_account_display_name_invalid = /** @type {(inputs: Account_Display_Name_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu nombre debe tener de 1 a 60 caracteres.`)
};

const pt_pt2_account_display_name_invalid = /** @type {(inputs: Account_Display_Name_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu nome tem de ter entre 1 e 60 caracteres.`)
};

const fr_fr2_account_display_name_invalid = /** @type {(inputs: Account_Display_Name_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton nom doit contenir entre 1 et 60 caractères.`)
};

const de_de2_account_display_name_invalid = /** @type {(inputs: Account_Display_Name_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Name muss 1 bis 60 Zeichen haben.`)
};

const it_it2_account_display_name_invalid = /** @type {(inputs: Account_Display_Name_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo nome deve avere da 1 a 60 caratteri.`)
};

/**
* | output |
* | --- |
* | "Your name needs 1 to 60 characters." |
*
* @param {Account_Display_Name_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const account_display_name_invalid = /** @type {((inputs?: Account_Display_Name_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Display_Name_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_account_display_name_invalid(inputs)
	if (locale === "es-419") return es_419_account_display_name_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_account_display_name_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_account_display_name_invalid(inputs)
	if (locale === "de-DE") return de_de2_account_display_name_invalid(inputs)
	if (locale === "it-IT") return it_it2_account_display_name_invalid(inputs)
	return en_us2_account_display_name_invalid(inputs)
});
export { account_display_name_invalid as "account.display_name_invalid" }